import React from 'react';

import { STRIPE_PUBLISHABLE_KEY } from 'constants/global';

const update = () => {
  const stripe = Stripe(STRIPE_PUBLISHABLE_KEY);

  if (!STRIPE_UPDATE_CARD_SESSION_ID) {
    bugsnag.notify('STRIPE_UPDATE_CARD_SESSION_ID not initialized');
    return;
  }

  stripe
    .redirectToCheckout({
      // Make the id field from the Checkout Session creation API response
      // available to this file, so you can provide it as parameter here
      // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      sessionId: STRIPE_UPDATE_CARD_SESSION_ID,
    })
    .then(function () {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    });
};

type Props = {};

export const UpdateCreditCardButton: React.FC<Props> = () => {
  return (
    <button
      disabled={STRIPE_UPDATE_CARD_SESSION_ID === undefined}
      onClick={update}
      title={STRIPE_UPDATE_CARD_SESSION_ID === undefined ? 'Unable to contact Stripe' : undefined}
      className='btn btn--border-dark btn--medium'
    >
      Update your credit card details
    </button>
  );
};
